module.exports = __webpack_public_path__ + "media/honey-icons/icon-compatible-897f9267.svg";